module.exports = new __parcel__URL__("issue-type-avatar-fallback.a9f6df1b.svg").toString();